export default {
  modules: {
    user: {
      namespaced: true,
      state: {
        user: {
          email: '',
          password: '',
          gender: '',
          given_name: '',
          family_name: ''
        }
      },
      actions: {
        setCredentials ({ commit }, payload) {
          commit('setCredentials', payload)
        }
      },
      mutations: {
        setCredentials (state, payload) {
          state.user.email = payload.email
          state.user.password = payload.password
          state.user.gender = payload.gender
          state.user.given_name = payload.given_name
          state.user.family_name = payload.family_name
        }
      },
      getters: {
        userCredentials: state => state.user
      }
    }
  }
}
